export default __webpack_public_path__ + "static/N0167-f3117a3ff9d4b1ed456121140b797e2c.png";